<template>
<div>
    <table class="goods-message-table">
        <!-- <template v-if="isPromotion"> -->
          <!--牙源通用促销活动商品促销活动不止一个-->
          <template v-if="isShowCashBack">
            <tr>
              <td :style="{width:tdMaxWidth+'px'}">促销活动：</td>
              <td>
               <div :class="$style['specification-table-div']" class="page-background">
                <table  :class="$style['specification-table']">
                    <th>
                        <td :style="{color:promotionData.promotionStatusColor+'!important'}">活动名称</td>
                        <td :style="{color:promotionData.promotionStatusColor+'!important'}">活动类型</td>
                        <td :style="{color:promotionData.promotionStatusColor+'!important'}">操作</td>
                    </th>
                    <tr v-for="(item,index) in abstractPromotionEvents" :key="index">
                        <td>{{item.promotionData&&item.promotionData.name}}</td>
                        <td >{{item.promotionData&&item.promotionData.promotion_type}}</td>
                        <td> <el-button type="text" @click.native="getDetail(item.id)">查看详情</el-button></td>
                    </tr>
                </table>
               </div>
              </td>
            </tr>
          </template>
          <template v-else>
            <template v-if="hasPromotion">
            <tr>
                <td :style="{color:promotionData.promotionStatusColor,width:tdMaxWidth+'px'}" >活动名称：</td>
                <td>{{promotionData.name}}</td>
            </tr>
            <tr>
                <td  :style="{color:promotionData.promotionStatusColor,width:tdMaxWidth+'px'}">活动类型：</td>
                <td>
                  <div :class="$style.promotionDataType">
                    <span>{{promotionData.promotion_type}} </span>
                  <el-button type="text" @click.native="getDetail()" v-if="!isShowPromotionPreTable">查看详情</el-button>
                  </div>
                  </td>
            </tr>
            <tr>
                <td  :style="{color:promotionData.promotionStatusColor,width:tdMaxWidth+'px'}">生效时间：</td>
                <td>{{promotionData.start_time}}至{{promotionData.end_time}}</td>
            </tr>
            </template>
          </template>
        <!-- </template> -->
        <tr v-if="!isExternalUrl">
            <td :style="{width:tdMaxWidth+'px'}">商品规格：</td>
            <td>
                <div :class="$style['specification-table-div']" class="page-background">

                <table  :class="$style['specification-table']">
                    <th>
                        <td>规格值</td>
                        <td>价格(元)</td>
                        <td :style="{color:promotionData.promotionStatusColor+'!important'}" v-if="isShowPromotionPreTable&&hasPromotion">促销价格</td>
                        <td>邀请人奖励</td>
                        <td>业务员奖励</td>
                        <td>奖励积分(积分)</td>
                    </th>
                    <tr v-for="(item,index) in specificationsItems" :key="index">
                        <td>{{item.name}}</td>
                        <td :style="{textDecoration:isExperiment&&isShowPromotionPreTable?'line-through' : 'none'}">{{justShow?'无需设置':item.show_detail_price}}</td>
                        <td :style="{color:promotionData.promotionStatusColor+'!important'}" v-if="isShowPromotionPreTable&&hasPromotion">{{item.promotion_price}}</td>
                        <td>{{item.inviterRewardMoney_show}}{{item.justSalesman?'(仅限业务员奖励)':null}}</td>
                        <td>{{item.salerRewardMoney_show}}</td>
                        <td>{{item.rewardPoint}}</td>
                    </tr>
                </table>
                </div>
            </td>
        </tr>
    </table>
        </div>
</template>
<script>
export default {
  props: {
    promotionEvent: {
      type: [Array, Object],
      default: function () {
        return []
      }
    },
    abstractPromotionEvents: {
      type: [Array, Object],
      default: function () {
        return []
      }
    },
    isExternalUrl: {
      type: Boolean,
      default: false
    },
    justShow: {
      type: Boolean,
      default: false
    },
    tdMaxWidth: {
      type: [Number, String],
      default: 0
    },
    id: {
      type: String,
      default: null
    },
    specifications: {
      type: Array,
      default: function () {
        return null
      }
    }
  },
  computed: {
    promotionData () {
      return this.promotionEvent.promotionData || {}
    },
    specificationsItems () {
      return (this.promotionEvent.promotionData && this.promotionEvent.promotionData.specifications && this.promotionEvent.promotionData.specifications[0] && this.promotionEvent.promotionData.specifications[0].items) || this.specifications
    },
    isExperiment () {
      return this.promotionIsExperiment()
    },
    // 促销活动部分是否显示商品规格表格
    isShowPromotionPreTable () {
      return this.promotionData.promotionType !== 'CASH_BACK'
    },
    // 是否拥有促销活动
    hasPromotion () {
      return this.abstractPromotionEvents && this.abstractPromotionEvents.length
    },
    // 判断是否显示促销活动表格，用于“通用活动”大于1个的时候
    isShowCashBack () {
      return this.promotionData.promotionType === 'CASH_BACK' && this.abstractPromotionEvents.length > 1
    }
  },
  methods: {
    getDetail (id) {
      id = id || this.id
      this.$router.push('/promotion-coupon/propmotion-detail/' + id)
    },
    // 判断促销活动是否正在进行
    promotionIsExperiment () {
      let promotionData = this.promotionEvent.promotionData || {}
      let timestamp = (new Date()).getTime()
      if (this.promotionEvent.status === 'ACTIVATED') {
        if (timestamp > promotionData.startTime && timestamp < promotionData.endTime) {
          console.log('进行中')
          return true
        } else if (timestamp < promotionData.startTime) {
          console.log('未开始')
          return false
        } else if (timestamp > promotionData.endTime) {
          console.log('已结束')
          return false
        }
      }
    }
  }
}
</script>
<style lang="less">
.goods-message-table{

}
</style>
<style module lang="less">
.specification-table-div{
    margin-bottom: 20px;
    padding: 10px 20px 30px;
}
.specification-table{
    display: table!important;
    width: 100%;
    border-collapse:collapse!important;
    th,tr{
        width: 100%!important;
        max-width: 100%!important;
        display: table-row!important;
        padding: 0!important;
        list-style-type:none;
        justify-content:center!important;
        border-bottom: 1px solid #C6C9D3;
        color: #5B5B5B!important;
    }
    td{
      display: table-cell!important;
        color: #5B5B5B!important;
        text-align: center;
        justify-content:flex-start!important;
        padding: 10px;
    }
}
.promotionDataType{
  display: flex;
  line-height: 30px;
  &>span{
  color: #2D2D2D!important;
  }
  :global
  .el-button{
    margin-left: 10px;
    padding: 0
  }
}
</style>
